<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
    <div fxFlex>Filter Options</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <mat-dialog-content class="mat-typography" fxFlex>
    <form>
      <app-options-card title="Filter By Agents Group" [options]="reportsService.groupsLookup" [collapsed]="false"
                        *ngIf="!data.hideAgentGroups"
                        [(checkedOptions)]="checkedAgentGroupsOptions" [showSearchInput]="true"></app-options-card>
      <app-options-card title="Filter By Hunt Group" [options]="reportsService.huntGroupsLookup" [collapsed]="false"
                        *ngIf="!data.hideHuntGroups"
                        [(checkedOptions)]="checkedHuntGroupsOptions" [showSearchInput]="true"></app-options-card>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="closeSendConfirmPopup('proceed')">Filter</button>
  </mat-dialog-actions>
</div>
